// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1D81Z","range":"MonthRangeSwitch_range__1lgix","disabled":"MonthRangeSwitch_disabled__3y_pn"};